import { useQuery } from '@tanstack/react-query';
import { getStoreScratcherReconciliationAuditsByRange } from 'services/auditService';

export function useStoreScratcherReconciliationAudits(
  storeId: string | null | undefined,
  startDate: string | null | undefined,
  endDate: string | null | undefined,
  enabled: boolean = true
) {
  return useQuery<any[]>({
    queryKey: ['store-scratcher-reconciliation-audits', storeId, startDate, endDate],
    queryFn: () => getStoreScratcherReconciliationAuditsByRange(storeId!, startDate!, endDate!),
    enabled: enabled && !!storeId && !!startDate && !!endDate,
  });
}
